import { render, staticRenderFns } from "./AddApiToken.vue?vue&type=template&id=8db6f6de&scoped=true"
import script from "./AddApiToken.vue?vue&type=script&lang=ts"
export * from "./AddApiToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db6f6de",
  null
  
)

export default component.exports